import { combineReducers } from 'redux';
import modalReducer from '../modal/modal-reducer';
import errorHandlingReducer from '../error-handling/error-handling-reducer';
import mleReducer from '../mle/mle-reducer';
import spinnerReducer from '../spinner/spinner-reducer';
import conquestReducer from '../conquest/conquest.reducer';

const CombinedReducers = combineReducers({
  modalReducer,
  errorHandlingReducer,
  mleReducer,
  spinnerReducer,
  conquestReducer
});

export default CombinedReducers;
